import { FaVolleyballBall, FaRunning } from "react-icons/fa";

import { GiFloorPolisher, GiShuttlecock } from "react-icons/gi";
// Hero Image
import heroImage from "../assets/services/tennis/hero.webp";
import overview1 from "../assets/services/tennis/overview1.jpg";
import overview2 from "../assets/services/tennis/overview2.webp";
import overview3 from "../assets/services/tennis/overview3.webp";
import overview4 from "../assets/services/tennis/overview4.webp";
/* =====================================================
   HERO STATS
===================================================== */

// Gallery Images
import gallery1 from "../assets/services/tennis/gallery1.jpg";
import gallery2 from "../assets/services/tennis/gallery2.jpg";
import gallery3 from "../assets/services/tennis/gallery3.jpg";
import gallery4 from "../assets/services/tennis/gallery4.jpg";

const tennisData = {
  /* =====================================================
     HERO
  ====================================================== */

  slug: "tennis",

  title: "Tennis Court Construction",

  subtitle: "Professional Acrylic Tennis Courts Built to ITF Standards",

  heroImage,

  overviewImages: [overview1, overview2, overview3, overview4],

  heroStats: [
    {
      value: "250+",
      label: "Courts Built",
    },

    {
      value: "15+",
      label: "Years Experience",
    },

    {
      value: "ITF",
      label: "Certified/Standard",
    },

    {
      value: "2 Yr",
      label: "Warranty",
    },
  ],

  breadcrumb: ["Home", "Services", "Tennis Court"],

  /* =====================================================
     OVERVIEW
  ====================================================== */

  overview: {
    title: "Professional Tennis Court Construction",

    description:
      "Quality Sports Surface specializes in designing and constructing international-standard tennis courts for schools, colleges, universities, sports academies, clubs, residential communities, and professional sports facilities. We use premium acrylic sports flooring systems engineered for durability, player safety, weather resistance, and exceptional performance.",
  },

  /* =====================================================
     BENEFITS
  ====================================================== */

  benefits: [
    {
      title: "ITF Standard Construction",
      description:
        "Designed according to international tennis court specifications.",
    },

    {
      title: "Premium Acrylic Surface",
      description:
        "High-performance acrylic flooring with excellent grip and durability.",
    },

    {
      title: "UV & Weather Resistant",
      description:
        "Built to withstand India's harsh climate and heavy rainfall.",
    },

    {
      title: "Low Maintenance",
      description:
        "Minimal maintenance with long-lasting color and surface quality.",
    },
  ],

  /* =====================================================
     CONSTRUCTION PROCESS
  ====================================================== */

  process: [
    {
      step: "01",
      title: "Site Inspection",
      description:
        "Complete site survey, measurements, and technical planning.",
    },

    {
      step: "02",
      title: "Base Preparation",
      description:
        "Concrete or asphalt base preparation with perfect leveling.",
    },

    {
      step: "03",
      title: "Acrylic Coating",
      description:
        "Multiple acrylic layers applied for strength and cushioning.",
    },

    {
      step: "04",
      title: "Court Marking",
      description: "Accurate FIBA-standard Tennis court line marking.",
    },

    {
      step: "05",
      title: "Final Inspection",
      description: "Complete quality inspection before project handover.",
    },
  ],

  /* =====================================================
     TECHNICAL SPECIFICATIONS
  ====================================================== */

  specifications: [
    {
      icon: "🏀",
      feature: "Surface Type",
      value: "Premium Acrylic Sports Flooring",
    },

    {
      icon: "🌦",
      feature: "Weather Resistance",
      value: "Excellent",
    },

    {
      icon: "👟",
      feature: "Slip Resistance",
      value: "High Grip Finish",
    },

    {
      icon: "☀",
      feature: "UV Resistant",
      value: "100% UV Stable",
    },

    {
      icon: "🏆",
      feature: "ITF Standard",
      value: "International Compliant",
    },

    {
      icon: "⏳",
      feature: "Expected Lifespan",
      value: "8+ Years",
    },

    {
      icon: "🛠",
      feature: "Maintenance",
      value: "Low Maintenance",
    },

    {
      icon: "🌍",
      feature: "Court Type",
      value: "Indoor & Outdoor",
    },
  ],

  /* =====================================================
   GALLERY SECTION
====================================================== */

  gallerySection: {
    tag: "FEATURED PROJECTS",

    title: "Our Recent Tennis Court Projects",

    description:
      "Explore some of the premium tennis courts successfully completed by Quality Sports Surface across India.",
  },

  /* =====================================================
     GALLERY
  ====================================================== */

  gallery: [
    {
      image: gallery1,
      title: "DRDO Kanchanbagh",
      location: "Hyderabad",
      surface: "Premium Acrylic Tennis Court",
      year: "2023",
    },

    {
      image: gallery2,
      title: "silver oak",
      location: "Hyderabad",
      surface: "Professional Acrylic Court",
      year: "2024",
    },

    {
      image: gallery3,
      title: "Sports Academy",
      location: "Hyderabad",
      surface: "Outdoor Tennis Court",
      year: "2024",
    },

    {
      image: gallery4,
      title: "University Campus",
      location: "Hyderbad",
      surface: "ITF Standard Court",
      year: "2025",
    },
  ],

  /* =====================================================
   WHY CHOOSE US — TENNIS
====================================================== */

  whyChoose: {
    tag: "WHY CHOOSE US",

    title: "Why Choose Our Professional Tennis Acrylic Flooring?",

    description:
      "We provide high-performance acrylic flooring solutions designed for indoor tennis facilities, offering excellent player safety, consistent movement, reliable grip and long-lasting durability. From premium hardwood selection to professional installation and finishing, we deliver complete tennis court flooring solutions.",

    features: [
      {
        title: "15+ Years Experience",
        description:
          "Over 15 years of experience delivering premium sports flooring and wooden court solutions for schools, academies, clubs, universities and professional sports facilities across India.",
      },

      {
        title: "1000+ Sports Projects",
        description:
          "Successfully completed 1000+ sports flooring projects, including tennis courts, indoor sports arenas, academies, training facilities and multi-purpose sports complexes.",
      },

      {
        title: "Premium Tennis Hardwood",
        description:
          "We use high-quality sports-grade hardwood selected for durability, stability, consistent performance and suitability for demanding tennis environments.",
      },

      {
        title: "Superior Shock Absorption",
        description:
          "Our flooring systems are designed to help absorb impact and reduce stress on players' knees, ankles and joints during running, jumping, sudden stops and rapid changes of direction.",
      },

      {
        title: "Excellent Grip & Movement",
        description:
          "Professionally finished surfaces provide controlled traction and consistent grip, helping players move confidently during rallies, sprints, lateral movements and quick directional changes.",
      },

      {
        title: "Consistent Playing Surface",
        description:
          "Precision installation and professional finishing create a smooth, uniform playing surface that supports predictable player movement and reliable court performance.",
      },

      {
        title: "Professional Court Finishing",
        description:
          "Our tennis flooring can be professionally sanded, sealed, coated and line-marked to create a clean, durable and competition-ready indoor tennis court.",
      },

      {
        title: "Durable & Long-Lasting",
        description:
          "Sports-grade hardwood, quality finishing materials and professional installation help the flooring withstand regular training sessions, matches and continuous facility usage.",
      },

      {
        title: "Custom Tennis Court Solutions",
        description:
          "We provide customized flooring solutions based on court dimensions, facility requirements, playing intensity, subfloor conditions, design preferences and project budget.",
      },

      {
        title: "Professional Installation Team",
        description:
          "Our experienced installation professionals handle subfloor preparation, hardwood installation, sanding, finishing and court marking with attention to precision and surface quality.",
      },

      {
        title: "On-Time Project Delivery",
        description:
          "Our structured project management process ensures efficient execution and helps complete tennis flooring projects within committed timelines with minimal disruption.",
      },

      {
        title: "Complete Project Support",
        description:
          "From initial consultation and site assessment to installation, court finishing, maintenance guidance and after-sales support, we provide complete assistance throughout the project.",
      },

      {
        title: "Maintenance & After-Sales Support",
        description:
          "We provide practical maintenance recommendations and ongoing support to help maintain the flooring's appearance, grip, durability and playing performance over time.",
      },
    ],
  },

  /* =====================================================
     FAQ
  ====================================================== */

  faqs: [
    {
      question: "How long does Tennis court construction take?",
      answer: "Normally between 25-35 days depending on project size.",
    },

    {
      question: "Can acrylic courts be used outdoors?",
      answer:
        "Yes. Acrylic sports flooring is specially designed for outdoor conditions.",
    },

    {
      question:
        "What type of sub-base prevents the courts surface from cracking?",
      answer:
        "Courts require a 40-60mm crushed stone base under a 35-45mm layer of asphalt or post-tensioned conrete offers the best protection against ground movement.",
    },

    {
      question: "How often does a tennis courts need to be resurfaced?",
      answer:
        "A standard acrylic hard court lasts 2-3 years before needing a need colour coat. Proper slope design prevents water pooling, which extends the surface lifespan.",
    },
  ],

  /* =====================================================
       RELATED SERVICES
    ====================================================== */

  relatedServices: [
    {
      icon: GiFloorPolisher,
      title: "Wooden-flooring",
      description: "Professional MFMA Standard Courts",
      link: "/services/wooden-flooring",
    },

    {
      icon: GiShuttlecock,
      title: "Badminton Court",
      description: "Professional BWF Standard Courts",
      link: "/services/badminton-court",
    },

    {
      icon: FaRunning,
      title: "Running Track",
      description: "Athletic Running Track Systems",
      link: "/services/running-track",
    },

    {
      icon: FaVolleyballBall,
      title: "Volleyball Court",
      description: "Professional FIVB Standard Courts",
      link: "/services/volleyball-court",
    },
  ],
  /* =====================================================
     CTA
  ====================================================== */

  cta: {
    title: "Ready to Build Your Tennis Court?",

    description:
      "Talk with our experts today and get a free consultation for your next sports infrastructure project.",
  },
};

export default tennisData;
